import { render, staticRenderFns } from "./ExportJson.vue?vue&type=template&id=0b74b388"
import script from "./ExportJson.vue?vue&type=script&lang=js"
export * from "./ExportJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports